var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveStates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.391,
    height: 13.337,
    viewBox: "0 0 137.391 13.337",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    transform: "translate(-57.37 -33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16015_00000062158986069588477250000014987507835292147879_",
    d: "M19.37,33h9.337a2,2,0,0,1,2,2v9.337a2,2,0,0,1-2,2H19.37a2,2,0,0,1-2-2V35A2,2,0,0,1,19.37,33Z",
    transform: "translate(40)",
    fill: "#1f70b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53847_00000171703514076989429010000001890292539172441235_",
    d: "M20.7,39.8l1.951,1.951,4.8-4.8",
    transform: "translate(40)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16016_00000077294649540906942270000009213717735376843160_",
    d: "M216.089,33h12a6.668,6.668,0,0,1,6.668,6.668h0a6.668,6.668,0,0,1-6.668,6.668h-12a6.668,6.668,0,0,1-6.668-6.668h0A6.668,6.668,0,0,1,216.089,33Z",
    transform: "translate(-40)",
    fill: "#1f70b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16017_00000080911655434142406440000015011720614140458174_",
    d: "M120.063,33h0a6.668,6.668,0,0,1,6.668,6.668h0a6.668,6.668,0,0,1-6.668,6.668h0a6.668,6.668,0,0,1-6.668-6.668h0A6.668,6.668,0,0,1,120.063,33Z",
    fill: "#1f70b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16018_00000093879497785372692140000010681504324577969033_",
    d: "M120.064,35.764h0a3.9,3.9,0,0,1,3.9,3.9h0a3.9,3.9,0,0,1-3.9,3.9h0a3.9,3.9,0,0,1-3.9-3.9h0A3.9,3.9,0,0,1,120.064,35.764Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16019_00000079484507912357460540000015536485516297851295_",
    d: "M215.755,34.334h.67a5,5,0,0,1,5,5V40a5,5,0,0,1-5,5h-.67a5,5,0,0,1-5-5v-.67A5,5,0,0,1,215.755,34.334Z",
    transform: "translate(-40)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveStates);
export default __webpack_public_path__ + "static/media/ActiveStates.780eb0b15913ea2ea7c0e38764676468.svg";
export { ForwardRef as ReactComponent };